import { render } from "./listCustomer.vue?vue&type=template&id=5f32f1fd&scoped=true"
import script from "./listCustomer.vue?vue&type=script&lang=js"
export * from "./listCustomer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f32f1fd"]])

export default __exports__